import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSortedThemes } from '../redux/selectors/PlacesThemeSorters';

import { changeSlide } from '../redux/actions/placesModalActions';

export default function withSortedPlacesThemes(ModalSlider) {
  const mapStateToProps = (state, ownProps) => {
    const { placesModal } = state;
    const { placeId } = ownProps;
    const { themeType, slideIndex } = placesModal;
    return {
      themes: getSortedThemes(state, { theme: themeType, placeId }),
      slideIndex: slideIndex,
      themeType,
      isLastPage: state.selectedPlace[themeType].isLastPage,
    };
  };

  const mapDispatchToProps = dispatch => ({
    changeSlide: (slideTo, slideIndex) => {
      dispatch(changeSlide({ slideTo, slideIndex }));
    },
  });
  class PlacesModalSlider extends Component {
    render() {
      return <ModalSlider {...this.props} />;
    }
  }
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(PlacesModalSlider);
}



// WEBPACK FOOTER //
// ./src/HOCs/withSortedPlacesThemes.jsx